import React, { useState, useEffect, useMemo, useContext } from "react";
// import PropTypes from "prop-types";
// import { Modal } from "flowbite-react";
// import Warning from "../../../../assets/images/warning.svg";
import { Pagination, ModalComponent } from "../../../components";
import restService from "../../../../restService";
import UserContext from "../../../../contexts/UserContext";
import { useNavigate } from "react-router-dom";
import CampaignContext from "../../../../contexts/CampaignContext";
import moment from "moment";
import es from "date-fns/esm/locale/es/index.js";
import { PulseLoader } from "react-spinners";
import { PulseLoader } from "react-spinners";
import Receipt from "../../../components/Receipt";
import {
  drawWinnersFiltersState,
  setDrawWinnersFilters,
} from "../../../../redux/entriesSlice";
import { useSelector, useDispatch } from "react-redux";

const Table = ({
  allDrawWinners,
  pageNumberLimit,
  maxPageNumberLimit,
  setMaxPageNumberLimit,
  minPageNumberLimit,
  setMinPageNumberLimit,
  rewardTypes,
  handleFetchDrawWinners,
  admins,
}) => {
  // const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const drawWinnersFilters = useSelector(drawWinnersFiltersState);

  const totalPages = drawWinnersFilters?.totalPages;
  const currentPage = drawWinnersFilters?.currentPage;

  const [user] = useContext(UserContext);
  const [campaign] = useContext(CampaignContext);
  // entry details states
  const [showModal, setShowModal] = useState(false);
  const [entryDetails, setEntryDetails] = useState(null);
  const [wantToBlock, setWantToBlock] = useState(false);
  const [wantToUnBlock, setWantToUnBlock] = useState(false);
  const [success, setSuccess] = useState(false);
  const [successfulBlock, setSuccessfulBlock] = useState(false);
  const [successfulUnBlock, setSuccessfulUnBlock] = useState(false);
  const [successfulSuspend, setSuccessfulSuspend] = useState(false);
  const [successfulUnSuspend, setSuccessfulUnSuspend] = useState(false);
  const [wantToSuspend, setWantToSuspend] = useState(false);
  const [wantToUnSuspend, setWantToUnSuspend] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [totalNumberOfEntries, setTotalNumberOfEntries] = useState("");
  const [loadingDetails, setLoadingDetails] = useState(false);
  const [totalWins, setTotalWins] = useState(0);
  const [openRewardModal, setOpenRewardModal] = useState(false);
  const [rewardedUser, setRewardedUser] = useState(false);
  const [entriesFound, setEntriesFound] = useState(false);
  const [isRewarding, setIsRewarding] = useState(false);
  const [drawWinnerID, setDrawWinnerID] = useState("");
  const [rewardTypeObject, setRewardTypeObject] = useState(null);
  const [viewReceipt, setViewReceipt] = useState(false);
  const [viewReceiptData, setViewReceiptData] = useState(null);
  const [somethingWentWrong, setSomethingWentWrong] = useState(false);
  const [enteredProxyNumber, setEnteredProxyNumber] = useState("");

  const handleClose = () => {
    setWantToBlock(false);
    setWantToUnBlock(false);
    setWantToSuspend(false);
    setWantToUnSuspend(false);
    setSuccessfulUnSuspend(false);
    setSuccess(false);
    setIsLoading(false);
    setEntryDetails({});
    setTotalNumberOfEntries("");
    setShowModal(false);
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const handleNextBtn = () => {
    dispatch(
      setDrawWinnersFilters({
        ...drawWinnersFilters,
        currentPage: currentPage + 1,
      })
    );

    scrollToTop();

    if (currentPage + 1 > maxPageNumberLimit) {
      setMaxPageNumberLimit(maxPageNumberLimit + pageNumberLimit);
      setMinPageNumberLimit(minPageNumberLimit + pageNumberLimit);
    }
  };

  const handlePageNumberClick = (e) => {
    dispatch(
      setDrawWinnersFilters({
        ...drawWinnersFilters,
        currentPage: Number(e.target.textContent),
      })
    );
  };

  const handlePrevBtn = () => {
    dispatch(
      setDrawWinnersFilters({
        ...drawWinnersFilters,
        currentPage: currentPage - 1,
      })
    );

    if ((currentPage - 1) % pageNumberLimit === 0) {
      setMaxPageNumberLimit(maxPageNumberLimit - pageNumberLimit);
      setMinPageNumberLimit(minPageNumberLimit - pageNumberLimit);
    }
  };

  const [showRegion, setShowRegion] = useState(false);
  const [showGender, setShowGender] = useState(false);
  const [drawWinnerProxyNumber, setDrawWinnerProxyNumber] = useState(null);

  useEffect(() => {
    allDrawWinners.map((winner) => {
      if (winner.entries) {
        setEntriesFound(true);
      }

      if (winner?.region) {
        setShowRegion(true);
      }
      if (winner?.gender) {
        setShowGender(true);
      }
    });

    // generate table  headers from the allDrawWinners
  }, [allDrawWinners]);

  const handleReward = async (winnerId, rewardId) => {
    setIsRewarding(true);

    try {
      const {
        data: { data },
      } = await restService.Entries.rewardDrawWinner(
        campaign.id,
        {
          drawWinnerId: winnerId,
          proxyNumber: enteredProxyNumber,
          rewardId: rewardId,
        },
        user.accessToken
      );

      setViewReceiptData(data);
      setIsRewarding(false);
      setRewardedUser(true);
      setOpenRewardModal(false);

      setViewReceipt(true);
      handleFetchDrawWinners && handleFetchDrawWinners();
    } catch (error) {
      console.log(error);
      setIsRewarding(false);
      setSomethingWentWrong(true);
    }
  };

  const handleBlockEntrant = async () => {
    setIsLoading(true);

    try {
      const data = await restService.Entries.blockEntrant(
        campaign.id,
        entryDetails.msisdn,
        user.accessToken
      );

      setWantToBlock(false);
      setWantToSuspend(false);
      setSuccessfulSuspend(false);
      setSuccessfulUnBlock(false);
      setSuccess(true);
      setSuccessfulBlock(true);
      setIsLoading(false);
    } catch (error) {
      console.log(error);
      setSuccess(false);
      setIsLoading(false);
      handleClose();
    }
  };

  const handleUnBlockEntrant = async () => {
    setIsLoading(true);

    try {
      const data = await restService.Entries.unBlockEntrant(
        campaign.id,
        entryDetails.msisdn,
        user.accessToken
      );

      setWantToBlock(false);
      setWantToUnBlock(false);
      setSuccessfulSuspend(false);
      setSuccessfulBlock(false);
      setWantToSuspend(false);
      setSuccess(true);
      setSuccessfulUnBlock(true);
      setIsLoading(false);
    } catch (error) {
      console.log(error);
      setSuccess(false);
      setIsLoading(false);
      handleClose();
    }
  };

  const handleSuspendEntrant = async () => {
    setIsLoading(true);

    try {
      const data = await restService.Entries.suspendEntrant(
        campaign.id,
        entryDetails.msisdn,
        user.accessToken
      );

      setWantToBlock(false);
      setWantToSuspend(false);
      setSuccessfulUnBlock(false);
      setSuccessfulBlock(false);
      setSuccess(true);
      setSuccessfulSuspend(true);
      setIsLoading(false);
    } catch (error) {
      console.log(error);
      setSuccess(false);
      setIsLoading(false);
      handleClose();
    }
  };

  const handleUnSuspendEntrant = async () => {
    setIsLoading(true);

    try {
      await restService.Entries.unSuspendEntrant(
        campaign.id,
        entryDetails.msisdn,
        user.accessToken
      );

      setWantToBlock(false);
      setWantToSuspend(false);
      setWantToUnSuspend(false);
      setSuccessfulUnBlock(false);
      setSuccessfulBlock(false);
      setSuccessfulSuspend(false);
      setSuccess(true);
      setSuccessfulUnSuspend(true);
      setIsLoading(false);
    } catch (error) {
      console.log(error);
      setSuccess(false);
      setIsLoading(false);
      handleClose();
    }
  };

  const handleGetUserState = async (msisdn) => {
    setLoadingDetails(true);

    try {
      const {
        data: { results },
      } = await restService.Entries.getUserState(
        campaign.id,
        msisdn,
        user.accessToken
      );

      return results;
    } catch (error) {
      console.log(error);
      return "";
    } finally {
      setLoadingDetails(false);
    }
  };

  const handleGetUserPoints = async (msisdn) => {
    setLoadingDetails(true);

    try {
      const {
        data: { data },
      } = await restService.PointsSystem.getUserPoints(
        campaign.id,
        msisdn,
        user.accessToken
      );

      return data;
    } catch (error) {
      console.log(error);
      return "";
    } finally {
      setLoadingDetails(false);
    }
  };

  const isSuspendedOrBlocked = async (msisdn) => {
    const userState = await handleGetUserState(msisdn);

    if ((await handleGetUserState(msisdn)?.toLowerCase()) === "suspended") {
      return "Suspended";
    } else if (handleGetUserState(msisdn)?.toLowerCase() === "blocked") {
      return "Blocked";
    } else {
      return "";
    }
  };

  const handleCloseRewardModal = () => {
    setSuccess(false);
    setOpenRewardModal(false);
    setDrawWinnerID("");
    setRewardTypeObject(null);
    setRewardedUser(false);
    setIsRewarding(false);
  };

  return (
    <>
      <div className="w-full overflow-auto">
        <table className="w-full ">
          <thead className="bg-[#F4F4F4] rounded  py-2">
            <tr className="">
              <th className="text-center whitespace-nowrap px-1 py-5 md:text-sm text-xs font-normal">
                Selection Date
              </th>

              {entriesFound && (
                <th className="text-center whitespace-nowrap px-1 py-5 md:text-sm text-xs font-normal">
                  Number of Entries
                </th>
              )}

              <th className="text-center whitespace-nowrap px-1 py-5 md:text-sm text-xs font-normal">
                Phone Number
              </th>

              <th className="text-center whitespace-nowrap px-1 py-5 md:text-sm text-xs font-normal">
                Name
              </th>

              {showGender && (
                <th className="text-center whitespace-nowrap px-1 py-5 md:text-sm text-xs font-normal">
                  Gender
                </th>
              )}
              {showRegion && (
                <th className="text-center whitespace-nowrap px-1 py-5 md:text-sm text-xs font-normal">
                  Region
                </th>
              )}
              <th className="text-center whitespace-nowrap px-1 py-5 md:text-sm text-xs font-normal">
                Number of Wins
              </th>

              <th className="text-center whitespace-nowrap px-1 py-5 md:text-sm text-xs font-normal">
                Action
              </th>
            </tr>
          </thead>
          <tbody>
            {allDrawWinners.length < 1 ? (
              <tr className="w-full">
                <td className="text-center" colSpan="5">
                  <div className="my-8 mx-auto">
                    <img
                      src={require("../../../../assets/images/noData.svg")}
                      alt=""
                      className="mx-auto"
                    />
                  </div>
                </td>
              </tr>
            ) : (
              allDrawWinners.map((drawWinner, index) => (
                <tr
                  key={index}
                  className="hover:bg-[#F4F4F4] hover:cursor-pointer active:bg-[#F4F4F4] focus:bg-[#F4F4F4]"
                >
                  <td className="text-center  text-xs md:text-sm text-[#787878] py-3 pl-0">
                    {moment(new Date(drawWinner?.date)).format(
                      "DD/MM/YYYY, h:mm:ss A"
                    )}
                  </td>

                  <td
                    className={`text-center  text-xs md:text-sm ${
                      // isSuspendedorBlocked(drawWinne) === "Suspended"
                      //   ? "text-red-800"
                      // :
                      "text-[#787878]"
                    }  py-3 pl-0`}
                  >
                    {drawWinner?.msisdn}
                  </td>

                  <td className="text-left  text-xs md:text-sm text-[#787878] py-3 pl-6">
                    {drawWinner?.name}
                  </td>

                  {showGender && (
                    <td
                      // onClick={async () => {
                      //   setShowModal(true);
                      //   setEntryDetails({
                      //     ...drawWinner,
                      //     userState: await handleGetUserState(drawWinner?.msisdn),
                      //     walletPoints: await handleGetUserPoints(
                      //       drawWinner?.msisdn
                      //     ),
                      //   });
                      // }}
                      className={`text-center  text-xs md:text-sm ${"text-[#787878]"}  py-3 pl-0`}
                    >
                      {drawWinner?.gender}
                    </td>
                  )}
                  {showRegion && (
                    <td
                      // onClick={async () => {
                      //   setShowModal(true);
                      //   setEntryDetails({
                      //     ...drawWinner,
                      //     userState: await handleGetUserState(drawWinner?.msisdn),
                      //     walletPoints: await handleGetUserPoints(
                      //       drawWinner?.msisdn
                      //     ),
                      //   });
                      // }}
                      className={`text-center  text-xs md:text-sm ${"text-[#787878]"}  py-3 pl-0`}
                    >
                      {drawWinner?.region}
                    </td>
                  )}

                  <td className="text-center  text-xs md:text-sm text-[#787878] py-3 pl-0">
                    {drawWinner.wins}
                  </td>

                  {entriesFound && (
                    <td
                      // onClick={async () => {
                      //   setShowModal(true);
                      //   setEntryDetails({
                      //     ...drawWinner,
                      //     userState: await handleGetUserState(drawWinner?.msisdn),
                      //     walletPoints: await handleGetUserPoints(
                      //       drawWinner?.msisdn
                      //     ),
                      //   });
                      // }}
                      className="text-center  text-xs md:text-sm text-[#787878] py-3 pl-0"
                    >
                      {drawWinner?.entries}
                    </td>
                  )}

                  <td className="text-center flex justify-center gap-5 item text-xs md:text-sm py-3 pl-6">
                    {drawWinner?.rewarded ? (
                      <button
                        onClick={() => {
                          setViewReceiptData(drawWinner);
                          setViewReceipt(true);
                        }}
                        className="text-left disabled:opacity-50  text-xs md:text-sm disabled:cursor-not-allowed border-solid text-[#3989DD] !border border-[#3989DD] rounded py-2 px-4 transition"
                      >
                        View receipt
                      </button>
                    ) : (
                      <button
                        disabled={
                          drawWinner?.rewarded || !admins?.includes(user?.id)
                        }
                        onClick={() => {
                          if (!admins?.includes(user?.id)) {
                            return;
                          }

                          if (drawWinner?.rewarded) {
                            return;
                          }

                          setIsRewarding(false);
                          setSuccess(false);

                          setDrawWinnerID(drawWinner?.msisdn);

                          setDrawWinnerProxyNumber(drawWinner?.proxyNumber);
                          setOpenRewardModal(true);
                        }}
                        className={`text-left disabled:opacity-50  text-xs md:text-sm disabled:cursor-not-allowed ${
                          drawWinner?.rewarded
                            ? "bg-[#00C74C]/10 text-[#00C74C] cursor-not-allowed"
                            : "bg-[#00C74C] text-[#ffff] hover:bg-[#01712c] "
                        }  rounded py-2 px-4 transition `}
                      >
                        {drawWinner?.rewarded ? "Rewarded" : "Reward"}
                      </button>
                    )}

                    <button
                      disabled
                      // onClick={() => {
                      //   setIsRewarding(false);
                      //   setSuccess(false);
                      //   setWinnerID(drawWinner.transactionId);
                      //   setOpen(true);
                      // }}
                      className="text-center px-3 cursor-not-allowed whitespace-nowrap text-xs md:text-sm border-[#848484] hover:bg-[#f4f4f4] border  rounded-[45px]"
                    >
                      {"Send Message"}
                    </button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      <div className="text-right py-4 px-5">
        <div className="flex items-center justify-end">
          <button
            onClick={() => handlePrevBtn()}
            disabled={
              totalPages &&
              currentPage ===
                [...Array(Math.max(0, totalPages - 1))].length - totalPages + 2
                ? true
                : false
            }
            className="disabled:hover:bg-[#F4F4F4] disabled:cursor-not-allowed disabled:text-[#848484] bg-[#F4F4F4] text-[#848484] mx-1 py-1.5 px-1 rounded text-sm hover:bg-[#FF6A3A] hover:text-white focus:bg-[#FF6A3A] focus:text-white"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-6 w-6"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              strokeWidth="2"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M15 19l-7-7 7-7"
              />
            </svg>
          </button>

          {totalPages &&
            [...Array(Math.max(0, totalPages))].map((value, index) => {
              if (
                index + 1 < maxPageNumberLimit + 1 &&
                index + 1 > minPageNumberLimit
              )
                return (
                  <button
                    key={index}
                    type="button"
                    onClick={(e) => handlePageNumberClick(e)}
                    className={
                      currentPage === index + 1
                        ? " mx-1 py-1.5 px-3 rounded text-sm bg-[#FF6A3A] text-white"
                        : "bg-[#F4F4F4] text-[#848484] mx-1 py-1.5 px-3 rounded text-sm hover:bg-[#FF6A3A] hover:text-white"
                    }
                  >
                    {index + 1}
                  </button>
                );
            })}
          <button
            onClick={() => handleNextBtn()}
            disabled={
              totalPages &&
              currentPage === [...Array(Math.max(0, totalPages))].length
                ? true
                : false
            }
            className="disabled:hover:bg-[#F4F4F4] disabled:cursor-not-allowed disabled:text-[#848484] bg-[#F4F4F4] text-[#848484] mx-1 py-1.5 px-1 rounded text-sm hover:bg-[#FF6A3A] hover:text-white focus:bg-[#FF6A3A] focus:text-white "
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-6 w-6"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              strokeWidth="2"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M9 5l7 7-7 7"
              />
            </svg>
          </button>
        </div>
      </div>

      {viewReceipt && (
        <div className="z-[999] absolute inset-0 flex items-center justify-center">
          <div
            onClick={() => {
              setViewReceipt(false);
              setViewReceiptData(null);
              setDrawWinnerID("");
              setRewardedUser(false);
              setDrawWinnerProxyNumber(null);
              setRewardTypeObject(null);
              setEnteredProxyNumber("");
            }}
            className="bg-black opacity-40 absolute inset-0 -z-0"
          ></div>

          <Receipt
            onClose={() => {
              setViewReceipt(false);
              setViewReceiptData(null);
              setDrawWinnerID("");
              setRewardedUser(false);
              setDrawWinnerProxyNumber(null);
              setRewardTypeObject(null);
              setEnteredProxyNumber("");
            }}
            data={viewReceiptData}
          />
        </div>
      )}

      <ModalComponent
        showModal={openRewardModal}
        width={"max-w-xl"}
        placement="center"
        setShowModal={setOpenRewardModal}
        handleClose={handleCloseRewardModal}
      >
        <>
          {!isRewarding && !rewardedUser && !somethingWentWrong ? (
            <div className="md:p-12 p-5 flex flex-col gap-4">
              <div className="mt-2 flex justify-center items-center flex-col gap-1">
                <h4 className=" mt-3 mb-0 text-[24px] font-bold text-start text-[#24211D]">
                  Careful!
                </h4>

                <p className=" text-center text-[#2f2f2f] text-sm">
                  You have triggered a reward process. This action cannot be
                  undone.
                </p>
              </div>

              <div className="flex flex-col gap-1">
                <label htmlFor="" className="text-sm">
                  Reward type
                </label>
                <select
                  required
                  onChange={(e) => {
                    setRewardTypeObject(JSON.parse(e.target.value));
                  }}
                  value={
                    rewardTypeObject ? JSON.stringify(rewardTypeObject) : ""
                  }
                  name="drawType"
                  id="drawType"
                  className="text-sm !capitalize rounded w-full invalid:text-[#848484] bg-[#F4F4F4] border-[#E6E6E6]"
                >
                  <option value="" selected disabled hidden>
                    Select reward type
                  </option>

                  {rewardTypes.map((rewardType) => (
                    <option
                      value={JSON.stringify(rewardType)}
                      className="!capitalize"
                    >
                      {rewardType?.type?.toLowerCase()?.includes("momo") ||
                      rewardType?.type?.toLowerCase()?.includes("airtime")
                        ? "GH₵" +
                          rewardType?.amount +
                          " " +
                          rewardType?.type?.toLowerCase()?.replace("_", " ")
                        : rewardType?.amount +
                          " " +
                          rewardType?.type?.toLowerCase()?.replace("_", " ")}
                    </option>
                  ))}
                  {/* <option value="WINS">Consumers with highest wins</option>
                  <option value="CUSTOM">Custom Draw Selection Criteria</option> */}
                </select>
              </div>

              <div className="flex flex-col gap-1">
                <label htmlFor="" className="text-sm">
                  Proxy number <span className="opacity-60">(optional)</span>
                </label>
                <input
                  onChange={(e) => {
                    setEnteredProxyNumber(e.target.value);
                  }}
                  className="text-sm !capitalize rounded w-full placeholder:opacity-50 invalid:text-[#848484] border-[#E6E6E6]"
                  type="number"
                  placeholder="233241234123"
                  value={enteredProxyNumber}
                />
              </div>

              <div className=" flex md:flex-row justify-center  items-center gap-1 md:gap-3 mt-12">
                <button
                  disabled={
                    !rewardTypeObject ||
                    isRewarding ||
                    !drawWinnerID ||
                    !admins?.includes(user?.id)
                  }
                  onClick={() => {
                    if (!admins?.includes(user?.id)) {
                      return;
                    }

                    handleReward(drawWinnerID, rewardTypeObject?.rewardId);
                  }}
                  className="bg-[#00C74C] disabled:bg-[#dcdbdb] md:text-base text-xs transition-all hover:bg-[#01953a] py-2 px-5 text-white rounded"
                >
                  Yes! Reward
                </button>
                <button
                  className=" border rounded py-2 md:text-base text-xs px-7 hover:bg-[#c700001a] hover:text-red-600"
                  onClick={() => {
                    handleCloseRewardModal();
                    setDrawWinnerID("");
                    setRewardTypeObject(null);
                    setRewardedUser(false);
                    setEnteredProxyNumber("");
                    setDrawWinnerProxyNumber(null);
                  }}
                >
                  Cancel
                </button>
              </div>
            </div>
          ) : isRewarding && !rewardedUser ? (
            <>
              <div className="md:p-12 p-5 flex justify-center flex-col items-center">
                <h4 className=" text-[24px] font-[700] text-[#24211D]">
                  Please wait...
                </h4>
                <p className=" text-[14px] text-[#b4b4b4]">Rewarding winner</p>

                <div className=" flex md:flex-row  items-center gap-1 md:gap-3 mt-1">
                  <PulseLoader color="#FF6A3A" />
                </div>
              </div>
            </>
          ) : (
            <>
              {somethingWentWrong && (
                <>
                  <div className="md:pb-2 md:pt-10 p-5 flex justify-center flex-col items-center">
                    <p className=" text-[14px] text-[#3f3f3f] text-center">
                      Something went wrong. Please try again
                    </p>
                    {/* <h4 className=" text-[24px] font-[700] text-[#24211D]">
                    {drawWinnerID}
                  </h4> */}
                  </div>

                  <div className=" flex md:flex-row justify-center  items-center gap-1 md:gap-3 mt-8">
                    <button
                      className=" border rounded py-2 mb-10 md:text-base text-xs px-7 hover:bg-[#ff0000] transition hover:text-white bg-[#c700001a] text-red-600"
                      onClick={() => {
                        handleCloseRewardModal();
                        setDrawWinnerID("");
                        setRewardedUser(false);
                        setRewardTypeObject(null);
                        setSomethingWentWrong(false);
                        setEnteredProxyNumber("");
                        setDrawWinnerProxyNumber(null);
                      }}
                    >
                      Close
                    </button>
                  </div>
                </>
              )}
            </>
          )}
        </>
      </ModalComponent>

      <ModalComponent
        showModal={showModal}
        width={"max-w-3xl"}
        setShowModal={setShowModal}
        handleClose={handleClose}
      >
        <div className="flex items-center flex-col w-full justify-center gap-9 py-[37px]">
          {loadingDetails ? (
            <PulseLoader color="#FF6A3A" />
          ) : (
            <>
              {" "}
              {entryDetails && (
                <>
                  {!wantToBlock &&
                    !wantToUnBlock &&
                    !wantToSuspend &&
                    !wantToUnSuspend &&
                    !success && (
                      <>
                        <h3 className="font-[700] text-[20px] text-[#24211D]">
                          Entry Details
                        </h3>

                        <div className="flex flex-col gap-5 w-full">
                          <div className="flex item-center justify-between w-full gap-11 ">
                            <div className="flex-1 flex items-center justify-end w-full">
                              <p className="text-base font-[400] text-[#848484]">
                                Phone Number:{" "}
                              </p>
                            </div>
                            <div className="flex flex-1 items-center justify-start w-full">
                              <p className="text-base text-[#24211D] font-[700]">
                                {entryDetails.msisdn}
                              </p>
                            </div>
                          </div>

                          <div className="flex item-center justify-between w-full gap-11">
                            {" "}
                            <div className="flex-1 flex items-center justify-end w-full">
                              <p className="text-base font-[400] text-[#848484]">
                                Selection Date:{" "}
                              </p>
                            </div>
                            <div className="flex flex-1 items-center justify-start w-full">
                              <p className="text-base text-[#24211D] font-[700]">
                                {moment(new Date(entryDetails?.date)).format(
                                  "DD/MM/YYYY, h:mm:ss A"
                                )}
                              </p>
                            </div>
                          </div>

                          <div className="flex item-center justify-between gap-11">
                            <div className="flex flex-1 items-center justify-end w-full">
                              <p className="text-base font-[400] text-[#848484]">
                                Number of Wins:{" "}
                              </p>
                            </div>
                            <div className="flex flex-1 items-center justify-start w-full">
                              <p className="text-base text-[#24211D] font-[700] capitalize">
                                {entryDetails.wins}
                              </p>
                            </div>
                          </div>

                          <div className="flex item-center justify-between gap-11">
                            <div className="flex flex-1 items-center justify-end w-full">
                              <p className="text-base font-[400] text-[#848484]">
                                Loyalty Points:{" "}
                              </p>
                            </div>
                            <div className="flex flex-1 items-center justify-start w-full">
                              <p className="text-base text-[#24211D] font-[700] capitalize">
                                {entryDetails?.walletPoints?.loyaltyPoints}
                              </p>
                            </div>
                          </div>

                          <div className="flex item-center justify-between gap-11">
                            <div className="flex flex-1 items-center justify-end w-full">
                              <p className="text-base font-[400] text-[#848484]">
                                Number of entries:{" "}
                              </p>
                            </div>
                            <div className="flex flex-1 items-center justify-start w-full">
                              <p className="text-base text-[#24211D] font-[700] capitalize">
                                {entryDetails.entries
                                  ? entryDetails.entries
                                  : "-"}
                              </p>
                            </div>
                          </div>
                        </div>

                        <div className="flex w-full items-center justify-between gap-11">
                          {entryDetails &&
                            entryDetails?.userState?.toLowerCase() !==
                              "blocked" &&
                            entryDetails?.userState?.toLowerCase() !==
                              "suspended" && (
                              <>
                                {" "}
                                <div className="flex flex-1 items-center justify-end w-full">
                                  <button
                                    onClick={() => setWantToSuspend(true)}
                                    className="bg-[#E41836] hover:bg-[#bb142d] text-white text-base font-[500] py-3 px-8 rounded"
                                  >
                                    Suspend
                                  </button>
                                </div>
                                <div className="flex flex-1 items-center justify-start w-full">
                                  <button
                                    onClick={() => setWantToBlock(true)}
                                    className="bg-[#24201D] hover:bg-[#35312e] text-white text-base font-[500] py-3 px-8 rounded"
                                  >
                                    Block Number
                                  </button>
                                </div>
                              </>
                            )}

                          {entryDetails &&
                            entryDetails?.userState?.toLowerCase() ===
                              "suspended" && (
                              <div className="flex flex-1 items-center justify-center w-full">
                                <button
                                  onClick={() => setWantToUnSuspend(true)}
                                  className="bg-[#E41836] hover:bg-[#bb142d] text-white text-base font-[500] py-3 px-8 rounded"
                                >
                                  Unsuspend
                                </button>
                              </div>
                            )}

                          {entryDetails &&
                            entryDetails?.userState?.toLowerCase() ===
                              "blocked" && (
                              <div className="flex flex-1 items-center justify-center w-full">
                                <button
                                  onClick={() => setWantToUnBlock(true)}
                                  className="bg-[#24201D] hover:bg-[#35312e] text-white text-base font-[500] py-3 px-8 rounded"
                                >
                                  Unblock Number
                                </button>
                              </div>
                            )}
                        </div>
                      </>
                    )}

                  {wantToSuspend && !success && (
                    <>
                      <h3 className="font-[700] text-[20px] text-[#24211D]">
                        Suspend Entrant
                      </h3>

                      <div className="flex flex-col gap-5 w-full">
                        <div className="flex item-center justify-between w-full gap-11 ">
                          <div className="flex-1 flex items-center justify-center w-full">
                            <p className="text-base text-center font-[400] text-[#848484]">
                              Are you sure you want to suspend this entrant?{" "}
                              <br />{" "}
                              <span className="text-base  text-[#24211D] font-[700]">
                                ({entryDetails.msisdn})
                              </span>
                            </p>
                          </div>
                        </div>
                      </div>

                      <div className="flex w-full items-center justify-between gap-11">
                        <div className="flex flex-1 items-center justify-end w-full">
                          <button
                            disabled={isLoading}
                            onClick={() => handleSuspendEntrant()}
                            className="bg-[#E41836] hover:bg-[#bb142d] text-white text-center text-base font-[500] py-3 px-8 rounded"
                          >
                            YES
                          </button>
                        </div>

                        <div className="flex flex-1 items-center justify-start w-full">
                          <button
                            onClick={() => setWantToSuspend(false)}
                            className="bg-[#24201D] hover:bg-[#35312e] text-white text-base font-[500] py-3 px-8 rounded"
                          >
                            NO
                          </button>
                        </div>
                      </div>
                    </>
                  )}
                  {wantToUnSuspend && !success && (
                    <>
                      <h3 className="font-[700] text-[20px] text-[#24211D]">
                        Unsuspend Entrant
                      </h3>

                      <div className="flex flex-col gap-5 w-full">
                        <div className="flex item-center justify-between w-full gap-11 ">
                          <div className="flex-1 flex items-center justify-center w-full">
                            <p className="text-base text-center font-[400] text-[#848484]">
                              Are you sure you want to unsuspend this entrant?{" "}
                              <br />{" "}
                              <span className="text-base  text-[#24211D] font-[700]">
                                ({entryDetails.msisdn})
                              </span>
                            </p>
                          </div>
                        </div>
                      </div>

                      <div className="flex w-full items-center justify-between gap-11">
                        <div className="flex flex-1 items-center justify-end w-full">
                          <button
                            disabled={isLoading}
                            onClick={() => handleUnSuspendEntrant()}
                            className="bg-[#E41836] hover:bg-[#bb142d] text-white text-center text-base font-[500] py-3 px-8 rounded"
                          >
                            YES
                          </button>
                        </div>

                        <div className="flex flex-1 items-center justify-start w-full">
                          <button
                            onClick={() => setWantToUnSuspend(false)}
                            className="bg-[#24201D] hover:bg-[#35312e] text-white text-base font-[500] py-3 px-8 rounded"
                          >
                            NO
                          </button>
                        </div>
                      </div>
                    </>
                  )}

                  {wantToBlock && !success && (
                    <>
                      <h3 className="font-[700] text-[20px] text-center text-[#24211D]">
                        {isLoading ? (
                          <>
                            Blocking {entryDetails.msisdn}
                            <br /> Please wait...{" "}
                          </>
                        ) : (
                          "Block Entrant"
                        )}
                      </h3>

                      <div className="flex flex-col gap-5 w-full">
                        <div className="flex item-center justify-between w-full gap-11 ">
                          <div className="flex-1 flex items-center justify-center w-full">
                            {isLoading ? (
                              <PulseLoader color="#FF6A3A" />
                            ) : (
                              <p className="text-base text-center font-[400] text-[#848484]">
                                Are you sure you want to block this entrant?{" "}
                                <br />{" "}
                                <span className="text-base  text-[#24211D] font-[700]">
                                  ({entryDetails.msisdn})
                                </span>
                              </p>
                            )}
                          </div>
                        </div>
                      </div>

                      {/* products consumed */}

                      <div className="flex w-full items-center justify-between gap-11">
                        {!isLoading && (
                          <>
                            {" "}
                            <div className="flex flex-1 items-center justify-end w-full">
                              <button
                                onClick={() => handleBlockEntrant()}
                                className="bg-[#E41836] hover:bg-[#bb142d] text-white text-center text-base font-[500] py-3 px-8 rounded"
                              >
                                YES
                              </button>
                            </div>
                            <div className="flex flex-1 items-center justify-start w-full">
                              <button
                                onClick={() => setWantToBlock(false)}
                                className="bg-[#24201D] hover:bg-[#35312e] text-white text-base font-[500] py-3 px-8 rounded"
                              >
                                NO
                              </button>
                            </div>
                          </>
                        )}
                      </div>
                    </>
                  )}
                  {wantToUnBlock && !success && (
                    <>
                      <h3 className="font-[700] text-[20px] text-center text-[#24211D]">
                        {isLoading ? (
                          <>
                            Unblocking {entryDetails.msisdn}
                            <br /> Please wait...{" "}
                          </>
                        ) : (
                          "Unblock Entrant"
                        )}
                      </h3>

                      <div className="flex flex-col gap-5 w-full">
                        <div className="flex item-center justify-between w-full gap-11 ">
                          <div className="flex-1 flex items-center justify-center w-full">
                            {isLoading ? (
                              <PulseLoader color="#FF6A3A" />
                            ) : (
                              <p className="text-base text-center font-[400] text-[#848484]">
                                Are you sure you want to unblock this entrant?{" "}
                                <br />{" "}
                                <span className="text-base  text-[#24211D] font-[700]">
                                  ({entryDetails.msisdn})
                                </span>
                              </p>
                            )}
                          </div>
                        </div>
                      </div>

                      <div className="flex w-full items-center justify-between gap-11">
                        {!isLoading && (
                          <>
                            {" "}
                            <div className="flex flex-1 items-center justify-end w-full">
                              <button
                                onClick={() => handleUnBlockEntrant()}
                                className="bg-[#E41836] hover:bg-[#bb142d] text-white text-center text-base font-[500] py-3 px-8 rounded"
                              >
                                YES
                              </button>
                            </div>
                            <div className="flex flex-1 items-center justify-start w-full">
                              <button
                                onClick={() => setWantToUnBlock(false)}
                                className="bg-[#24201D] hover:bg-[#35312e] text-white text-base font-[500] py-3 px-8 rounded"
                              >
                                NO
                              </button>
                            </div>
                          </>
                        )}
                      </div>
                    </>
                  )}

                  {success && (
                    <>
                      <h3 className="font-[700] text-[20px] text-center text-[#24211D]"></h3>

                      <div className="flex flex-col gap-5 w-full">
                        <div className="flex item-center justify-between w-full gap-11 ">
                          <div className="flex-1 flex items-center justify-center w-full">
                            <p className="text-base text-center font-[400] text-[#848484]">
                              {successfulBlock
                                ? "Successfully blocked"
                                : successfulUnBlock
                                ? "Successfully unblocked"
                                : successfulSuspend
                                ? "Successfully suspended"
                                : "Successfully unsuspended"}{" "}
                              <br />{" "}
                              <span className="text-base  text-[#24211D] font-[700]">
                                ({entryDetails.msisdn})
                              </span>
                            </p>
                          </div>
                        </div>
                      </div>

                      <div className="flex w-full items-center justify-between gap-11">
                        <div className="flex flex-1 items-center justify-center w-full">
                          <button
                            onClick={() => handleClose()}
                            className="bg-[#24201D] hover:bg-[#35312e] text-white text-base font-[500] py-3 px-8 rounded"
                          >
                            CLOSE
                          </button>
                        </div>
                      </div>
                    </>
                  )}
                </>
              )}
            </>
          )}
        </div>
      </ModalComponent>
    </>
  );
};

export default Table;
